module.exports = __webpack_public_path__ + "img/down-hn3.8a61503a.jpg";